import { useState, useEffect } from 'react';
import { syncQueue } from '@/lib/syncQueue';

export interface NetworkStatus {
  isOnline: boolean;
  pendingMutations: number;
}

export function useNetworkStatus(): NetworkStatus {
  const [isOnline, setIsOnline] = useState(() => 
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );
  const [pendingMutations, setPendingMutations] = useState(() => 
    syncQueue.getPendingCount()
  );

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Subscribe to sync queue changes
    const unsubscribe = syncQueue.subscribe(() => {
      setPendingMutations(syncQueue.getPendingCount());
    });

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      unsubscribe();
    };
  }, []);

  return { isOnline, pendingMutations };
}
